<template>
  <fragment>

    <fragment>
      <div class="container border">
        <h6>Add Actions</h6>
        <div class="row align-items-start">
          <label class="col-sm-2 mb-sm-0">Status:</label>
          <app-input class="col-sm-8 mt-sm-2"
                     type="select"
                     :list="statusList"
                     v-model="status"
                     :required="true"/>
          <div class="col-sm-2"></div>
          <label for="Date" class="col-sm-2 mb-sm-0">Select Date</label>
          <app-input
            class="col-sm-8 mt-sm-2"
              type="date"
              v-model="statusDate"
              today
          />
          <div class="col-sm-2"></div>
          <label class="col-sm-2 mb-sm-0">Write a comment:</label>
          <app-input
            class="col-sm-8 direction-input mt-sm-2"
              type="textarea"
              v-model="commentText"
              placeholder="Write Comment"
          />
          <div class="col-sm-12 mt-sm-2">
          <multi-upload-btn
            ref="multiUpload"
            :uploadedFile="this.uploadedFile"
            :emailAddress="this.emailAddress"
          />
          </div>
          <div class="col-sm-12">
            <el-button class="secondary mt-2"
                       @click="saveComment()">
              Save Comment
            </el-button>

          </div>
        </div>
      </div>

    </fragment>
    <fragment v-if="showSteps">
      <comments-steps-tree :steps="steps"
                           @node-delete="deleteNode"
                           @node-edit="editNode"/>
    </fragment>

  </fragment>
</template>

<script>
import {Comment} from "@Views/Screening/utility/apiAgent";
import {_status, oralSteps, writtenSteps} from "@Views/Screening/utility/constant";
import {updateCommentSteps} from "@Views/Screening/utility/common/comment";

export default {
  name: "GeneralComments",
  props: {
    showSteps: {
      type: Boolean,
      default: true
    },
    comments: {
      type: Array,
      default: () => []
    },
    emailAddress: {
      type: String
    },
    applicantId: {
      type: Number,
    },
    statusable_type: {
      type: String
    },
    statusable_id: {
      type: Number,
    }
  },
  data() {
    return {
      steps: [],
      commentText: '',
      status: '',
      statusDate: '',
      uploadedFile: [],
      statusList: _status,
      oralSteps: oralSteps,
      writtenSteps: writtenSteps
    };
  },
  created() {
    this.setStepsOnInitialization();
  },
  methods: {
    updateCommentSteps,
    async saveComment() {
      if (this.commentText != '') {
        await this.$refs.multiUpload.submitUpload();
        const commentObj = {
          statusable_type: this.statusable_type,
          statusable_id: this.statusable_id,
          status: this.status,
          created_at: this.statusDate,
          action_comment: this.commentText,
          applicant_files: this.uploadedFile.map(x => x.id)
        };
        Comment.saveComment(this.applicantId, commentObj)
            .then(({data}) => {
              this.comments.push({id: data.screeningStatus.id, ...commentObj});
              this.updateCommentSteps({id: data.screeningStatus.id, ...commentObj}, false);
              this.$emit('status-saved', {
                comment: { id: data.screeningStatus.id, ...commentObj },
                uploadedFiles: [...this.uploadedFile]
              });
              this.status = '';
              this.uploadedFile.splice(0);
              this.$hub.$emit('clear-uploaded-files');
              this.commentText = '';
              this.$toastr.s(data.message);
              //todo need to add condition for search only - trigger
              this.$hub.$emit('pass-steps-in-search-case', data.screeningStatus);

            });
      }else if (this.statusable_type === null || this.statusable_type === undefined){
        this.$toastr.i("Comment type is missing.");
      }else{
        this.$toastr.i("Comment is required.");
      }
    },
    deleteNode(commentObj) {
      if (!window.confirm("Are you sure you want to delete this action?")) {
        return;
      }
      const commentId = commentObj.id;
      Comment.deleteComment(commentId)
          .then(() => {
            let indexToRemove = this.steps.findIndex(step =>
                step.children?.some(child => child.id === commentId)
            );
            if (indexToRemove !== -1) {
              this.steps[indexToRemove].children = this.steps[indexToRemove].children.filter(child => child.id !== commentId);
              if (this.steps[indexToRemove].children.length === 0) {
                this.steps.splice(indexToRemove, 1);
              }
            }
            this.$toastr.s("Comment and associated files deleted successfully!");
          })
          .catch(error => {
            this.$toastr.e("Failed to delete comment.");
            console.error(error);
          });
    },
    editNode(event) {
    },
    setStepsOnInitialization() {
      for (const _comment of this.comments) {
        const o = {
          id: _comment.id,
          created_at: _comment.created_at,
          include_in_report: _comment.include_in_report,

          action_comment: _comment.action_comment,
          status: _comment.status,
          applicant_files: _comment.applicant_files,
          statusable_id: _comment.statusable_id,
          statusable_type: _comment.statusable_type
        };
        this.updateCommentSteps(o, true);
      }
    },
  }
}
</script>

<style scoped>
.direction-input {
  direction: ltr;
}

.direction-label {
  text-align: left;
}
</style>
